import { Modal, Typography, message } from 'antd';

import { useUpdateInvoice } from '@/hooks/mutations/admin';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  orderId: number;
  onSuccess: () => void;
}

const InvoiceModal = ({ onClose, onSuccess, isOpen, orderId }: Props) => {
  const updateInvoice = useUpdateInvoice({
    onSuccess: () => {
      onClose();
      message.success('세금계산서 발행 상태가 변경됐어요');
      onSuccess();
    },
  });

  return (
    <Modal
      centered
      width={320}
      open={isOpen}
      onClose={onClose}
      onCancel={onClose}
      onOk={() => {
        updateInvoice.mutate({
          id: orderId,
          isInvoiced: true,
        });
      }}
      title="세금계산서 발행"
    >
      <Typography.Text type="secondary">
        세금계산서 발행 후에는 상태 변경이 불가능합니다. 발행 완료로
        처리하시겠어요?
      </Typography.Text>
    </Modal>
  );
};

export default InvoiceModal;
